import * as urlUtils from 'utils/Url';


export function getPathPromptOverview(qs={}) {
  return urlUtils.appendQueryString(`/prompt-overview`, qs);
}

export function getPathPromptConnections(qs={}) {
  return urlUtils.appendQueryString(`/prompt-connections`, qs);
}

// App-level analytics dashboard (distinct from per-prompt getPathPromptAnalytics).
export function getPathPromptAnalyticsDashboard(qs={}) {
  return urlUtils.appendQueryString(`/prompt-analytics`, qs);
}

export function getPathPrompts(qs={}) {
  return urlUtils.appendQueryString(`/prompts`, qs);
}

export function getPathAddPrompt() {
  return `/prompts/add`;
}

export function getPathEditPrompt(promptId) {
  return `/prompts/${promptId}/edit`;
}

export function getPathReplicatePrompt(promptId) {
  return `/prompts/${promptId}/replicate`;
}

export function getPathPromptAnalytics(promptId, qs={}) {
  return urlUtils.appendQueryString(`/prompts/${promptId}/analytics`, qs);
}

export function getPathPromptSales(promptId, qs={}) {
  return urlUtils.appendQueryString(`/prompts/${promptId}/sales`, qs);
}

export function getPathPromptResponses(promptId, qs={}) {
  return urlUtils.appendQueryString(`/prompts/${promptId}/responses`, qs);
}

export function getPathPromptSyncLogs(promptId, qs={}) {
  return urlUtils.appendQueryString(`/prompts/${promptId}/sync-logs`, qs);
}

export function getPathPromptPreview(promptId) {
  return `/prompts/${promptId}/preview`;
}
